import _defineProperty from "/vercel/path0/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _slicedToArray from "/vercel/path0/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js";
import _objectWithoutProperties from "/vercel/path0/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["variant", "actions"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import _styled from "styled-components";
import * as React from 'react';
import { CheckIcon, EllipsisHorizontalIcon } from '@heroicons/react/24/outline';
import { EyeIcon, EyeSlashIcon } from '@heroicons/react/24/solid';
import { Badge, Button, Dropdown, IconButton } from '@restworld/ui-ds-base';
import { useTranslation } from 'next-i18next';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";

var CardContainer = /*#__PURE__*/_styled.div.withConfig({
  displayName: "reference-card__CardContainer",
  componentId: "sc-5d3nxw-0"
})(["", " ", ""], {
  "display": "inline-flex",
  "width": "100%",
  "minWidth": "320px",
  "maxWidth": "42rem",
  "flexDirection": "column",
  "alignItems": "center",
  "justifyContent": "flex-start",
  "gap": "1.5rem",
  "borderRadius": "1rem",
  "--tw-bg-opacity": "1",
  "backgroundColor": "rgb(250 250 250 / var(--tw-bg-opacity))",
  "padding": "1rem",
  "paddingTop": "0.5rem",
  "outlineStyle": "solid",
  "outlineWidth": "1px",
  "outlineOffset": "-1px",
  "outlineColor": "#858591"
}, function (_ref) {
  var variant = _ref.variant;
  return variant === 'new_received' && {
    "paddingTop": "1rem"
  };
});

var CardContent = /*#__PURE__*/_styled.div.withConfig({
  displayName: "reference-card__CardContent",
  componentId: "sc-5d3nxw-1"
})(["", ""], {
  "display": "flex",
  "flexDirection": "column",
  "alignItems": "flex-start",
  "justifyContent": "flex-start",
  "gap": "1rem",
  "alignSelf": "stretch"
});

var CardHeader = /*#__PURE__*/_styled.h5.withConfig({
  displayName: "reference-card__CardHeader",
  componentId: "sc-5d3nxw-2"
})(["", ""], {
  "justifyContent": "flex-start",
  "alignSelf": "stretch"
});

var Highlight = /*#__PURE__*/_styled.span.withConfig({
  displayName: "reference-card__Highlight",
  componentId: "sc-5d3nxw-3"
})(["", ""], {
  "fontSize": "1rem",
  "lineHeight": "1.5rem",
  "fontWeight": "700",
  "--tw-text-opacity": "1",
  "color": "rgb(28 28 51 / var(--tw-text-opacity))"
});

var Normal = /*#__PURE__*/_styled.span.withConfig({
  displayName: "reference-card__Normal",
  componentId: "sc-5d3nxw-4"
})(["", ""], {
  "fontSize": "1rem",
  "lineHeight": "1.5rem",
  "fontWeight": "400",
  "--tw-text-opacity": "1",
  "color": "rgb(28 28 51 / var(--tw-text-opacity))"
});

var ReferenceBox = /*#__PURE__*/_styled.div.withConfig({
  displayName: "reference-card__ReferenceBox",
  componentId: "sc-5d3nxw-5"
})(["", " ", ""], {
  "display": "inline-flex",
  "alignItems": "center",
  "justifyContent": "center",
  "gap": "0.625rem",
  "alignSelf": "stretch",
  "borderRadius": "0.5rem",
  "padding": "1rem"
}, function (_ref2) {
  var _ref2$bgColor = _ref2.bgColor,
      bgColor = _ref2$bgColor === void 0 ? 'neutral-30' : _ref2$bgColor;
  return bgColor === 'purple-50' ? {
    "--tw-bg-opacity": "1",
    "backgroundColor": "rgb(240 235 248 / var(--tw-bg-opacity))"
  } : {
    "--tw-bg-opacity": "1",
    "backgroundColor": "rgb(235 235 237 / var(--tw-bg-opacity))"
  };
});

var ReferenceText = /*#__PURE__*/_styled.h5.withConfig({
  displayName: "reference-card__ReferenceText",
  componentId: "sc-5d3nxw-6"
})(["", " ", ""], {
  "flex": "1 1 0%",
  "justifyContent": "flex-start",
  "fontSize": "1rem",
  "lineHeight": "1.5rem",
  "fontWeight": "400",
  "--tw-text-opacity": "1",
  "color": "rgb(28 28 51 / var(--tw-text-opacity))"
}, function (_ref3) {
  var _ref3$textColor = _ref3.textColor,
      textColor = _ref3$textColor === void 0 ? 'neutral-700' : _ref3$textColor;
  return textColor === 'neutral-200' ? {
    "--tw-text-opacity": "1",
    "color": "rgb(102 102 118 / var(--tw-text-opacity))"
  } : {
    "--tw-text-opacity": "1",
    "color": "rgb(28 28 51 / var(--tw-text-opacity))"
  };
});

var Divider = /*#__PURE__*/_styled.hr.withConfig({
  displayName: "reference-card__Divider",
  componentId: "sc-5d3nxw-7"
})(["", ""], {
  "position": "relative",
  "height": "1px",
  "alignSelf": "stretch",
  "borderRadius": "9999px",
  "--tw-bg-opacity": "1",
  "backgroundColor": "rgb(222 222 225 / var(--tw-bg-opacity))"
});

var Actions = /*#__PURE__*/_styled.div.withConfig({
  displayName: "reference-card__Actions",
  componentId: "sc-5d3nxw-8"
})(["", " ", ""], {
  "position": "relative",
  "display": "inline-flex",
  "alignItems": "center",
  "justifyContent": "flex-start",
  "gap": "1rem",
  "alignSelf": "stretch"
}, function (_ref4) {
  var loading = _ref4.loading;
  return loading && {
    "pointerEvents": "none"
  };
});

var DateText = /*#__PURE__*/_styled.h5.withConfig({
  displayName: "reference-card__DateText",
  componentId: "sc-5d3nxw-9"
})(["", ""], {
  "alignSelf": "flex-start",
  "fontSize": "0.875rem",
  "lineHeight": "1.25rem",
  "fontWeight": "400",
  "--tw-text-opacity": "1",
  "color": "rgb(102 102 118 / var(--tw-text-opacity))"
});

var ReferenceCardBase = function ReferenceCardBase(_ref5) {
  var employerName = _ref5.employerName,
      venueName = _ref5.venueName,
      referenceText = _ref5.referenceText,
      badge = _ref5.badge,
      dropdownItems = _ref5.dropdownItems,
      actions = _ref5.actions,
      showDate = _ref5.showDate,
      madeVisibleToEmployerAt = _ref5.madeVisibleToEmployerAt,
      variant = _ref5.variant,
      workingRelationship = _ref5.workingRelationship;

  var _useTranslation = useTranslation('worker-references-page'),
      t = _useTranslation.t;

  return /*#__PURE__*/_jsxs(CardContainer, {
    variant: variant,
    children: [/*#__PURE__*/_jsxs(CardContent, {
      children: [/*#__PURE__*/_jsxs(_StyledDiv, {
        children: [badge, dropdownItems && /*#__PURE__*/_jsx(Dropdown, {
          triggerElement: /*#__PURE__*/_jsx(IconButton, {
            Icon: EllipsisHorizontalIcon,
            ariaLabel: "options"
          }),
          items: dropdownItems
        })]
      }), /*#__PURE__*/_jsxs(CardHeader, {
        children: [/*#__PURE__*/_jsx(Highlight, {
          children: employerName
        }), /*#__PURE__*/_jsxs(Normal, {
          children: [", ", t('reference_card.title.your_former_employee'), " "]
        }), /*#__PURE__*/_jsx(Highlight, {
          children: workingRelationship
        }), /*#__PURE__*/_jsxs(Normal, {
          children: [" ", t('reference_card.title.at'), " "]
        }), /*#__PURE__*/_jsx(Highlight, {
          children: venueName
        }), /*#__PURE__*/_jsxs(Normal, {
          children: [", ", t('reference_card.title.wrote_you_this_reference'), ":"]
        })]
      }), /*#__PURE__*/_jsx(ReferenceBox, {
        bgColor: variant === 'visible' ? 'purple-50' : 'neutral-30',
        children: /*#__PURE__*/_jsx(ReferenceText, {
          textColor: variant === 'hidden' ? 'neutral-200' : 'neutral-700',
          children: referenceText
        })
      })]
    }), actions, showDate && /*#__PURE__*/_jsx(DateText, {
      children: madeVisibleToEmployerAt
    })]
  });
};

export var ReferenceCard = function ReferenceCard(_ref6) {
  var variant = _ref6.variant,
      actions = _ref6.actions,
      rest = _objectWithoutProperties(_ref6, _excluded);

  var _useTranslation2 = useTranslation('worker-references-page'),
      t = _useTranslation2.t;

  var _React$useState = React.useState(),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      action = _React$useState2[0],
      setAction = _React$useState2[1];

  switch (variant) {
    case 'new_received':
      return /*#__PURE__*/_jsx(ReferenceCardBase, _objectSpread(_objectSpread({}, rest), {}, {
        badge: /*#__PURE__*/_jsx(Badge, {
          variant: "fresh",
          children: /*#__PURE__*/_jsx("span", {
            role: "img",
            "aria-label": "badge",
            children: t('reference_card.new_reference')
          })
        }),
        actions: /*#__PURE__*/_jsxs(_Fragment, {
          children: [/*#__PURE__*/_jsx(Divider, {}), /*#__PURE__*/_jsxs(Actions, {
            children: [/*#__PURE__*/_jsx(_StyledButton, {
              fullwidth: true,
              variant: "tertiary",
              StartIcon: EyeSlashIcon,
              onClick: function onClick() {
                var _actions$onHideRefere;

                setAction('reject');
                actions === null || actions === void 0 ? void 0 : (_actions$onHideRefere = actions.onHideReference) === null || _actions$onHideRefere === void 0 ? void 0 : _actions$onHideRefere.call(actions);
              },
              loading: action === 'reject' && (actions === null || actions === void 0 ? void 0 : actions.loading),
              children: t('reference_card.actions.secondary')
            }), /*#__PURE__*/_jsx(Button, {
              fullwidth: true,
              variant: "primary",
              StartIcon: CheckIcon,
              onClick: function onClick() {
                var _actions$onShowRefere;

                setAction('accept');
                actions === null || actions === void 0 ? void 0 : (_actions$onShowRefere = actions.onShowReference) === null || _actions$onShowRefere === void 0 ? void 0 : _actions$onShowRefere.call(actions);
              },
              loading: action === 'accept' && (actions === null || actions === void 0 ? void 0 : actions.loading),
              children: t('reference_card.actions.primary')
            })]
          })]
        }),
        variant: variant
      }));

    case 'visible':
      return /*#__PURE__*/_jsx(ReferenceCardBase, _objectSpread(_objectSpread({}, rest), {}, {
        badge: /*#__PURE__*/_jsx(Badge, {
          variant: "restworld",
          icon: EyeIcon,
          children: t('reference_card.visible_to_employers')
        }),
        dropdownItems: [{
          label: t('reference_card.actions.hide_reference'),
          Icon: EyeSlashIcon,
          onClick: function onClick() {
            var _actions$onHideRefere2;

            actions === null || actions === void 0 ? void 0 : (_actions$onHideRefere2 = actions.onHideReference) === null || _actions$onHideRefere2 === void 0 ? void 0 : _actions$onHideRefere2.call(actions);
          }
        }],
        showDate: true,
        variant: variant
      }));

    case 'hidden':
    default:
      return /*#__PURE__*/_jsx(ReferenceCardBase, _objectSpread(_objectSpread({}, rest), {}, {
        badge: /*#__PURE__*/_jsx(Badge, {
          variant: "disabled",
          icon: EyeSlashIcon,
          children: t('reference_card.only_visible_to_you')
        }),
        dropdownItems: [{
          label: t('reference_card.actions.show_reference'),
          Icon: EyeIcon,
          onClick: function onClick() {
            var _actions$onShowRefere2;

            actions === null || actions === void 0 ? void 0 : (_actions$onShowRefere2 = actions.onShowReference) === null || _actions$onShowRefere2 === void 0 ? void 0 : _actions$onShowRefere2.call(actions);
          }
        }],
        showDate: true,
        variant: variant
      }));
  }
};
export default ReferenceCard;

var _StyledDiv = /*#__PURE__*/_styled("div").withConfig({
  displayName: "reference-card___StyledDiv",
  componentId: "sc-5d3nxw-10"
})({
  "display": "inline-flex",
  "alignItems": "center",
  "justifyContent": "space-between",
  "alignSelf": "stretch"
});

var _StyledButton = /*#__PURE__*/_styled(Button).withConfig({
  displayName: "reference-card___StyledButton",
  componentId: "sc-5d3nxw-11"
})({
  "--tw-shadow": "0 0 #0000",
  "--tw-shadow-colored": "0 0 #0000",
  "boxShadow": "var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow)"
});